/* @flow */
import BoxBody from 'components/BoxBody';
import Dialog from 'components/Dialog';
import * as React from 'react';
import TextAppLink from 'user/components/TextAppLink';

export default class extends React.Component<$FlowFixMeProps> {
  render() {
    return (
      <Dialog
        eventScreenName="TextAppLinkDialog"
        className="TextAppLinkDialog"
        size="large"
        onRequestHide={this.props.onRequestHide}>
        <BoxBody>
          <TextAppLink />
        </BoxBody>
      </Dialog>
    );
  }
}
